export default __webpack_public_path__ + "static/media/f3.f44a42ee.png";